<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn
                    color="indigo"
                    class="white--text"
                    :to="{ name: 'emails/create' }"
                >
                    <v-icon left>mdi-email-plus</v-icon>
                    {{ $t('emails-index.buttons.create') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table" :headers="headers">
                    <template #active="{ item }">
                        <v-icon :color="item.active ? 'green' : 'red'">
                            {{ item.active ? 'mdi-check' : 'mdi-close' }}
                        </v-icon>
                    </template>

                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-close</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.delete') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <confirm ref="confirm" confirmText="Remover"></confirm>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Confirm from '@/components/dialogs/Confirm'
import Email from '@/models/Email'

export default {
    components: {
        'sarala-table': SaralaTable,
        confirm: Confirm,
    },

    computed: {
        model() {
            return new Email()
        },
        headers() {
            return [
                {
                    text: 'Título',
                    value: 'title',
                },
                {
                    text: 'Ativo',
                    value: 'active',
                },
                {
                    text: this.$t('tables.actions'),
                    value: 'action',
                    width: 150,
                    sortable: false,
                    align: 'end',
                },
            ]
        },
    },

    methods: {
        editItem(item) {
            this.$router.push({
                name: 'emails/edit',
                params: { id: item.id },
            })
        },

        async deleteItem(item) {
            let confirm = await this.$refs.confirm.open(
                this.$t('emails-index.messages.delete'),
                this.$t('emails-index.messages.delete-confirmation', {
                    email: item.title,
                }),
            )

            if (!confirm) return

            let clone = item.clone()

            let res = await clone.delete()

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('emails-index.bus.delete-error', {
                        email: item.title,
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('emails-index.bus.delete-success', {
                    email: item.title,
                }),
            )
        },
    },
}
</script>
